import { MatElementsModule } from './../_modules/mat-elements.module';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';


import { TrimbleFeePaymentRoutingModule } from './trimble-fee-payment-routing.module';
import { PaylayoutComponent } from './paylayout.component';
import { PayStudentComponent } from './pay-student.component';

import { MatIconModule } from '@angular/material/icon';
import { TrimbleCaptureResponseComponent } from './trimble-capture-response.component';

@NgModule({

  imports: [
    CommonModule,
    ReactiveFormsModule,
    TrimbleFeePaymentRoutingModule,
    MatElementsModule,
    MatIconModule
  ],
  declarations: [
    PaylayoutComponent,
    PayStudentComponent,
    TrimbleCaptureResponseComponent
  ]
})
export class TrimbleFeePaymentModule { }
